/**
 * 跨端 Guard 契约：前端生图前校验与后端 BusinessAssert 门控对齐语义。
 * 前端 UX 拦截；后端为安全与一致性边界（见 docs/image-generation-guards.md）。
 */

export type GuardResult = { ok: true } | { ok: false; message: string; code?: string };

export type GuardFn = () => GuardResult;

/** 按序执行，遇首个失败即返回 */
export function runGuards(...guards: GuardFn[]): GuardResult {
  for (const guard of guards) {
    const result = guard();
    if (!result.ok) return result;
  }
  return { ok: true };
}

export function guardOk(): GuardResult {
  return { ok: true };
}

export function guardFail(message: string, code?: string): GuardResult {
  const trimmed = message.trim();
  return { ok: false, message: trimmed || "校验未通过", code };
}

/** 与后端 ErrorCode 无耦合的客户端 Guard 码（日志/埋点用） */
export const IMAGE_GEN_GUARD_CODE = {
  NO_REFERENCE_CAPABLE_MODEL: "image_gen.no_reference_capable_model",
  PLATFORM_MISSING: "image_gen.platform_missing",
  MODEL_MISSING: "image_gen.model_missing",
  MODEL_INVALID: "image_gen.model_invalid",
  MODEL_NO_REFERENCE: "image_gen.model_no_reference",
  SIZE_MISSING: "image_gen.size_missing",
  SIZE_INVALID: "image_gen.size_invalid",
} as const;

export type ImageGenGuardCode = (typeof IMAGE_GEN_GUARD_CODE)[keyof typeof IMAGE_GEN_GUARD_CODE];
